import { useState } from "react"

const useSlider = () => {
    const [sliders, _] = useState([
        {
            "img": "/assets/img/sliders/slider_1.jpeg",
            "label": "PPG Daljab Kemenag",
            "description": "Ciptakan guru profesional, lahirkan generasi unggul"
        },
        {
            "img": "/assets/img/sliders/slider_2.jpg",
            "label": "Guru Agama Hebat",
            "description": "Guru agama hebat lahir dari pendidikan karakter kuat"
        },
        {
            "img": "/assets/img/sliders/slider_3.jpg",
            "label": "Guru Madrasah",
            "description": "Mengabdi dengan ilmu, mendidik dengan hati"
        },
        {
            "img": "/assets/img/sliders/slider_4.jpeg",
            "label": "Merawat Keberagaman, Memantapkan Keberagaman",
            "description": ""
        }
    ])

    return { sliders }
}


export default useSlider